"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _calculateFivePercentsAdd = _interopRequireDefault(require("./calculateFivePercentsAdd"));

var _calculateAdditionalContribution = _interopRequireDefault(require("./calculateAdditionalContribution"));

var _calculateKPPContribution = _interopRequireDefault(require("./calculateKPPContribution"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = function _default(employees, fot, contribution, avgPayment, antikrizis) {
  //дополнительные расходы при индексации зп: сумма роста объема фот после индексации и доп страховых взносов
  var indexation = (0, _calculateFivePercentsAdd.default)(fot, contribution, antikrizis) + (0, _calculateAdditionalContribution.default)(employees, fot, contribution, avgPayment); // бюджет на внедрение КПП: стартовый взнос в кпп + целевой взнос в НПФ

  var motivation = (0, _calculateFivePercentsAdd.default)(fot, contribution, antikrizis) + (0, _calculateKPPContribution.default)(fot, contribution, antikrizis);
  return indexation - motivation;
};

exports.default = _default;